export enum AllRoutes {
    HOME = '/',
    PRISE_CARBURANT = '/prise-carburant',
    PAIEMENT = '/paiement',
    CARTE = '/carte',
    COMPTE_UTILISATEUR = '/compte-utilisateur',
    POINT_OF_SALE_MASTER_DATA = '/point-of-sale-master-data',
    PRIX = '/config-prix',
    JOURNALISATION = '/journalisation',
    LOG = '/log',
    CLIENT = '/client',
    PERMISSION = '/permission',
    ABOUT = '/about',
    RELEVE_CLIENT = '/releve-client',
    LIVRAISON_CARTE_REPORT = '/livraison-carte-report',

    // utilities ===

    // LOCKED_CARDS_UTILITY = '/utilities/locked-cartes',
}
